/* ChazaCo — banderas en el selector de mercado.
   Convierte el ISO 3166-1 alpha-2 (ej. "CO", "PA") a su emoji de bandera
   via Regional Indicator Symbols, sin necesitar un set de assets SVG por pais. */
(function () {
  function isoToFlagEmoji(iso) {
    if (!iso || iso.length !== 2) return '';
    return iso
      .toUpperCase()
      .replace(/./g, function (char) {
        return String.fromCodePoint(127397 + char.charCodeAt(0));
      });
  }

  function paintFlags() {
    document.querySelectorAll('.localization-selector[data-iso-code]').forEach(function (btn) {
      var flagEl = btn.querySelector('.chz-flag');
      if (flagEl) flagEl.textContent = isoToFlagEmoji(btn.dataset.isoCode);
    });

    document.querySelectorAll('.country-selector [data-value]').forEach(function (link) {
      var flagEl = link.querySelector('.chz-flag');
      if (flagEl) flagEl.textContent = isoToFlagEmoji(link.dataset.value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintFlags);
  } else {
    paintFlags();
  }
})();
